import type { HttpTransport } from "@common/api/transport";
import type { PaginatedResponse } from "@common/types/api";
import type { Tag } from "@common/types/Note";

export const createTagsApi = (http: HttpTransport) => ({
  fetchTags: () => http.get<PaginatedResponse<Tag>>("/api/tags")
});
